import React from 'react';
import ReactDOM from 'react-dom/client';
import { setup } from 'goober';
import App from './App';
import "./assets/styles/index.css"
import './assets/fonts/fonts.css';
import './i18n/i18n';

// Налаштування goober для роботи з React
setup(React.createElement);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);